module.exports = __webpack_public_path__ + "static/img/model-bg25.0a01a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg25.jpg
// module id = OTNO
// module chunks = 0